window.TooltipEventInfo = (function () {
    var container, innerContainer, tooltipClass;

    var TooltipEventInfo = function () {
        container = $('<div/>', {
            class: 'tooltip--event tooltip event-tooltip',
        });

        innerContainer = $('<div/>', {
            class: 'tooltip__inner event-tooltip__inner',
        }).appendTo(container);

        container.appendTo('body');

        isMobile = globalAppSettings.isMobileDevice;

        bindUI();
    };

    var bindUI = function () {
        $(document).on('mouseenter', '[tooltip-event-info]', function () {
            mouseenterHandler($(this));
        });

        if (isMobile) {
            $(document).on('touchstart', function () {
                hide();
            });
        } else {
            $(document).on('mouseleave', '[tooltip-event-info]', function () {
                hide($(this));
            });
        }
    };

    var mouseenterHandler = function (elem) {
        var data = {
            id: elem.attr('data-id'),
            date: elem.attr('data-date'),
            tv: elem.attr('data-tv'),
            title: elem.attr('data-title'),
            league: elem.attr('data-league'),
            comment: elem.attr('data-comment'),
        };

        tooltipClass = elem.attr('tooltip-class');

        if (tooltipClass) {
            container.addClass(tooltipClass);
        }

        var html = [
            '<div class="event-tooltip__header">',
            '<span class="event-tooltip__id">' + data.id + '</span>',
            '<span class="event-tooltip__date">' + data.date + '</span>',
            data.tv
                ? '<span class="event-tooltip__tv">' +
                  data.tv +
                  '</span><div class="icon-tv-tooltip"></div>'
                : '',
            '</div>',
            '<div class="event-tooltip__title">' + data.title + '</div>',
            data.league
                ? '<div class ="event-tooltip__league">' +
                  data.league +
                  '</div>'
                : '',
            data.comment
                ? '<div class ="event-tooltip__comment">' +
                  data.comment.trim() +
                  '</div>'
                : '',
        ].join('\n');

        innerContainer
            .html(html)
            .promise()
            .done(function () {
                innerContainer.height('auto');
                setPosition(elem);
            });

        // dispatch event for Matomo Analytics
        document.dispatchEvent(
            new CustomEvent('showEventTooltip', {
                detail: {
                    data,
                    element: elem[0],
                },
            })
        );

        elem.on('remove', function () {
            hide(elem);
        });
    };

    var setPosition = function (element) {
        var elementOffset = element.offset(),
            elementWidth = element.outerWidth(),
            tooltipOffset = {
                left: 0,
                top: 0,
            },
            tooltipWidth = container.outerWidth(),
            tooltipHeight = container.outerHeight(),
            positionClassname = 'top';

        // по умолчанию отображается сверху от элемента
        tooltipOffset.left = elementOffset.left + elementWidth - tooltipWidth;
        tooltipOffset.top = elementOffset.top - tooltipHeight + 3;

        container.show();

        container
            .css({
                left: tooltipOffset.left,
                top: tooltipOffset.top,
            })
            .off('transitionend')
            .addClass(positionClassname + ' visible');
    };

    var hide = function (elem) {
        if (elem) {
            elem.off('remove');
        }

        if (tooltipClass) {
            container.removeClass(tooltipClass);
            tooltipClass = null;
        }

        container.removeClass('visible').on('transitionend', function () {
            container.hide();
            container.removeClass('left right top bottom');
        });
    };

    var update = function (elem) {
        if (elem) mouseenterHandler(elem);
    };

    $(function () {
        TooltipEventInfo();
    });

    return {
        update: update,
        hide: hide,
    };
})();
